/** Explicit navigation actions take priority over a pending back-navigation scroll restore. */
export const SCROLL_TO_TOP_EVENT = 'myungchisa:scroll-to-top';

export function scrollPageToTop(): void {
    window.dispatchEvent(new Event(SCROLL_TO_TOP_EVENT));
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
}
